<template>
  <div class="group-setup">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="pa-5">
      <v-card-title dark>
        <h3 class="ma-2">Honoring of Past District Governors</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.name"
              label="Name"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <DatePicker
              :lable="'Date'"
              v-model="form.date"
              :setectVale="form.date"
              @changeInput="form.date = $event"
            ></DatePicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.is_before_date"
              label="Complete the Before Date"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document1"
              prepend-icon="mdi-paperclip"
              label="Attach a copy of attendance"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document2"
              prepend-icon="mdi-paperclip"
              label="Photo"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="success"
              depressed
              :disabled="loading || !form.date"
              block
              @click="submit()"
              >Submit to Review</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";
import DatePicker from "@/components/shared/DatePicker";

export default {
  name: "HonoringPastPresident",

  components: { Alert, DatePicker },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      is_before_date: 0,
      date: null,
      name: "",
      document1: null,
      document2: null,
    },
  }),

  mounted() {},

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      this.errors = null;
      this.loading = true;
      this.snackbar = false;
      let fd = new FormData();

      fd.append("document1", this.form.document1);
      fd.append("document2", this.form.document2);
      fd.append(
        "is_before_date",
        this.form.is_before_date == null ? 0 : this.form.is_before_date
      );
      fd.append("date", this.form.date);
      fd.append("name", this.form.name);
      fd.append("month", this.$route.params.month);
      fd.append("key", "HONORING_OF_PAST_DISTRICTS");

      let data = fd;
      ActivityService.submitCommonActivity(data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.$router.push("/activities/monthly");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    changeMembers(value) {
      this.form.member_id = value;
    },

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
  },
};
</script>
